<app-atlas-hero-panel></app-atlas-hero-panel>
<!-- <app-common-companies-panel
  [companiesData]="companiesData"
></app-common-companies-panel> -->
<altas-payment-digital-platform></altas-payment-digital-platform>
<app-common-discover-why
  [discoverData]="discoverData"
  [bgWhite]="true"
></app-common-discover-why>
<atlas-embedded-collection></atlas-embedded-collection>




<app-common-explore-global-panel
  [exploreData]="exploreMore"
  [noRedirect]="true"
></app-common-explore-global-panel>
<app-common-faq
  [faqData]="faqData"
></app-common-faq>
<app-atlas-ready-to></app-atlas-ready-to>
<!-- <app-common-ready-to [readyToData]="readyToData" [notInside]="true"></app-common-ready-to> -->
<app-common-latest-news
  [blogData]="newsList"
></app-common-latest-news>
